import { render, staticRenderFns } from "./MonthlyWiseProfitReport.vue?vue&type=template&id=c8b4103a&"
import script from "./MonthlyWiseProfitReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyWiseProfitReport.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyWiseProfitReport.vue?vue&type=style&index=0&id=c8b4103a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports